
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!content_migrations.progressing_content_migration_collection";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'content-migrations/ProgressingContentMigrationCollection';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "\n<ul class=\"unstyled collectionViewItems row-fluid\"></ul>\n";
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n<p>\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("content_migrations.progressing_content_migration_collection")
  },data:data},helper ? helper.call(depth0, "no_items", "No jobs have been queued", options) : helperMissing.call(depth0, "t", "no_items", "No jobs have been queued", options)))
    + "\n</p>\n";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "";
  buffer += "\n\n";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<p><em>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'ENV.CONTENT_MIGRATIONS_EXPIRE_DA': (((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CONTENT_MIGRATIONS_EXPIRE_DAYS)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "content_import_files_cannot_be_downloaded_after_en_7e3a2099", "Content import files cannot be downloaded after %{ENV.CONTENT_MIGRATIONS_EXPIRE_DA} days.", options) : helperMissing.call(depth0, "t", "content_import_files_cannot_be_downloaded_after_en_7e3a2099", "Content import files cannot be downloaded after %{ENV.CONTENT_MIGRATIONS_EXPIRE_DA} days.", options)))
    + "</em></p>\n";
  return buffer;
  }

  buffer += "<h2><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("content_migrations.progressing_content_migration_collection")
  },data:data},helper ? helper.call(depth0, "progress_label", "Current Jobs", options) : helperMissing.call(depth0, "t", "progress_label", "Current Jobs", options)))
    + "</strong></h2>\n<hr aria-hidden=\"true\">\n\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CONTENT_MIGRATIONS_EXPIRE_DAYS), 0, options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CONTENT_MIGRATIONS_EXPIRE_DAYS), 0, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  